module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-bar-left-94238c6d.svg";